import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {FuseAnimate, FuseUtils} from '@fuse'
import {bindActionCreators} from 'redux'
import ReactTable from "react-table"
import {Button, MenuItem, Select} from "@material-ui/core"
import {UecareStatus} from "../../../../components"
import {constDataDialogs} from "../../../../constants"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import ReduxVip from "../../../../store/actionreducers/vip"
import ReduxSurveyCount from "../../../../store/actionreducers/surveyCount"

class SurveyCountList extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id])
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText)
    };

    render() {
        const {searchText, openDataDialog, surveyCount, getMission} = this.props

        const data = this.getFilteredArray(surveyCount, searchText)

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何意見回饋"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    data={data
                        .sort((preMission, currMission) => currMission.id - preMission.id)
                    }
                    columns={[
                        {
                            Header: '任務編號',
                            accessor: 'no',
                            filterable: true,
                            className: 'justify-center',
                            width: 150,
                        },
                        {
                            Header: '會員名稱',
                            accessor: 'requester.user',
                            filterable: true,
                            width: 120,
                            Cell: row => {
                                const user = row.value
                                return (
                                    <div className="flex flex-1 flex-row items-center ">
                                         {user.name}
                                    </div>
                                );
                            },
                            filterMethod: (filter, row) => {
                                let name = ''
                                if (row._original.requester){
                                    name = row._original.requester.user.name
                                }
                                const filterValue = filter.value.filterValue;
                                if (!filterValue || filterValue.length === 0) return true;
                                else return name && name.indexOf(filterValue) > -1;
                            },
                        },
                        {
                            Header: '醫師名稱',
                            accessor: 'provider.user',
                            filterable: true,
                            width: 120,
                            Cell: row => {
                                const user = row.value;
                                if (user) {

                                    return (
                                        <div className="flex flex-1 flex-row items-center ">
                                            {user.name}
                                        </div>
                                    );
                                 } else return '';
                            },
                            filterMethod: (filter, row) => {
                                let name = ''
                                if (row._original.provider){
                                    name = row._original.provider.user.name
                                }
                                const filterValue = filter.value.filterValue;
                                if (!filterValue || filterValue.length === 0) return true;
                                else return name && name.indexOf(filterValue) > -1;
                            },
                        },
                        {
                            Header: '所屬醫院',
                            accessor: 'provider',
                            filterable: true,
                            width: 120,
                            Cell: row => {
                                const {hospital, unvalidated_hospital_name} = row.value || {};
                                if (!!hospital) {
                                    return (
                                        <div className="flex flex-1 flex-row items-center ">
                                            {hospital.name}
                                        </div>
                                    );
                                } else return unvalidated_hospital_name || '';
                            },
                            filterMethod: (filter, row) => {
                                let name = ''
                                if (row._original.provider){
                                    name = (row._original.provider.hospital && row._original.provider.hospital.name)
                                        || row._original.provider.unvalidated_hospital_name
                                }
                                const filterValue = filter.value.filterValue;
                                if (!filterValue || filterValue.length === 0) return true;
                                else return name && name.indexOf(filterValue) > -1;
                            },
                        },
                        {
                            Header: '會員職業',
                            accessor: 'career',
                            filterable: true,
                            Cell: row => ({
                                agricultural: '農牧業',  fishery: '漁業', forestry: '木材森林業', mining: '礦業採石業',
                                hospitality: '餐旅業', architects: '建築工程業', manufacturing: '製造業', news: '新聞廣告業',
                                health: '衛生保健', recreation: '娛樂業', education: '文教機關', religious: '宗教團體',
                                public: '公共事業', service: '服務業', housekeeper: '家庭管理', information: '資訊業',
                                security: '治安人員', army: '軍人', sports: '運動人員', other: '其他',
                            }[row.value]),
                            Filter: ({ filter, onChange }) => (
                                <Select
                                    onChange={({ target: { value } }) => onChange(value)}
                                    style={{ width: '100%' }}
                                    value={filter ? filter.value : ''}
                                >
                                    <MenuItem value="all">全部</MenuItem>
                                    <MenuItem value="agricultural">農牧業</MenuItem>
                                    <MenuItem value="fishery">漁業</MenuItem>
                                    <MenuItem value="forestry">木材森林業</MenuItem>
                                    <MenuItem value="mining">礦業採石業</MenuItem>
                                    <MenuItem value="hospitality">餐旅業</MenuItem>
                                    <MenuItem value="architects">建築工程業</MenuItem>
                                    <MenuItem value="manufacturing">製造業</MenuItem>
                                    <MenuItem value="news">新聞廣告業</MenuItem>
                                    <MenuItem value="health">衛生保健</MenuItem>
                                    <MenuItem value="recreation">娛樂業</MenuItem>
                                    <MenuItem value="education">文教機關</MenuItem>
                                    <MenuItem value="religious">宗教團體</MenuItem>
                                    <MenuItem value="public">公共事業</MenuItem>
                                    <MenuItem value="service">服務業</MenuItem>
                                    <MenuItem value="housekeeper">家庭管理</MenuItem>
                                    <MenuItem value="information">資訊業</MenuItem>
                                    <MenuItem value="security">治安人員</MenuItem>
                                    <MenuItem value="army">軍人</MenuItem>
                                    <MenuItem value="sports">運動人員</MenuItem>
                                    <MenuItem value="other">其他</MenuItem>
                                </Select>
                            ),
                            filterMethod: ({ value } , { career }) => value === 'all' || value === career,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '醫師專業度',
                            accessor: 'medicalProfessional',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '問題解決度',
                            accessor: 'medicalSolved',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '視訊品質',
                            accessor: 'flowSatisfied',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '持續使用率',
                            accessor: 'platformKeepUsing',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '已使用次數',
                            accessor: 'usageCount',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '整體滿意度',
                            accessor: 'platformSatisfied',
                            filterable: false,
                            className: 'justify-center',
                            width: 120,
                        },
                        {
                            Header: '建議',
                            accessor: 'platformSuggestion',
                            filterable: false,
                            Cell: row => (
                                row.original.platformSuggestion &&
                                row.original.platformSuggestion.length &&
                                <Button
                                    onClick={async ev => {
                                        try {
                                            ev.stopPropagation()
                                            await getMission(row.original.id)
                                            openDataDialog({
                                                type: constDataDialogs.type.view,
                                                name: constDataDialogs.name.surveyFeedbackDialog,
                                            })
                                        } catch (e) {
                                            console.warn('you got an error = ', e)
                                        }
                                    }}
                                >{row.original.platformSuggestion}</Button>
                            ) || '無建議',
                            className: 'justify-center',
                            width: 250,
                        },
                    ]}
                    defaultPageSize={5}
                />
            </FuseAnimate>
        );
    }

}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVip: ReduxVip.ActionCreator.getVip,
        getMission: ReduxSurveyCount.ActionCreator.getMission,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch)
}

function mapStateToProps({global: {searchText}}) {
    return {searchText}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyCountList)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/surveyCount/SurveyCountList.js